import script from "./DecorTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./DecorTitle.vue?vue&type=script&setup=true&lang=ts"

import "./DecorTitle.vue?vue&type=style&index=0&id=efecad88&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efecad88"]])

export default __exports__